'use client';

import { useCallback, type MouseEvent } from 'react';
import { useModal } from 'components/shared/Modal';
import AppHandoffModal from '../AppHandoffModal';
import PartnerTypeformModal from '../PartnerTypeformModal';
import { openPulsomicsApp, pulsomicsJoinLink } from '../deeplinks';
import typeStyles from '../typography.module.css';

/**
 * The two actions in the institutions band — the only interactive part of the
 * section, split out so the band itself stays a Server Component. Renders as a
 * fragment: the row that holds these lives in InstitutionsCTA.module.css.
 */
const InstitutionsCtaButtons = () => {
  const ModalClient = useModal();

  /* Same handoff as every other Join on the page: a phone tries the app and
     falls back to its store, desktop gets the QR dialog. */
  const handleJoin = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      if (openPulsomicsApp(pulsomicsJoinLink())) return;
      ModalClient.set(
        <AppHandoffModal
          heading="Join Pulsomics in the app"
          text="Scan to install it on your phone."
        />,
      );
      ModalClient.show();
    },
    [ModalClient],
  );

  const openPartnerForm = useCallback(() => {
    ModalClient.set(
      <PartnerTypeformModal source="pulsomics_institutions_cta" />,
    );
    ModalClient.setCloseButtonTheme('dark');
    ModalClient.setPortal(true);
    ModalClient.show();
  }, [ModalClient]);

  return (
    <>
      <a
        className={typeStyles.pillSolidOnDark}
        href="#how-it-works"
        onClick={handleJoin}
        aria-label="Join Pulsomics in the Ultrahuman app"
      >
        Join Pulsomics
      </a>
      <button
        className={typeStyles.pillLinedOnDark}
        type="button"
        onClick={openPartnerForm}
      >
        Partner with Ultrahuman
      </button>
    </>
  );
};

export default InstitutionsCtaButtons;
